import "bootstrap/dist/css/bootstrap.min.css";
// import "./src/css/palette.css";
import "./src/css/custom.scss";
import "./src/css/normalize.css";
import "./static/fonts/fonts.css";
import "animate.css/animate.min.css";
export const onServiceWorkerUpdateReady = () => window.location.reload(true);
